module.exports = __webpack_public_path__ + "img/SL-M-140-210.a32456cc.svg";